// Custom packages
import { ApiService } from "./api.service";
import * as i0 from "@angular/core";
import * as i1 from "./api.service";
var FileService = /** @class */ (function () {
    /**
     * Class constructor
     */
    function FileService(apiService) {
        this.apiService = apiService;
    }
    /**
     * Upload file
     *
     * @since 1.0.0
     *
     * @returns Observable<any>
     */
    FileService.prototype.uploadImportingFiles = function (file, endpoint) {
        if (endpoint && endpoint === 'supplier') {
            return this.apiService.apiCall("POST", "temp-files", file, {
                contentType: "auto"
            }, true, true);
        }
        return this.apiService.apiCall("POST", "files", file, {
            contentType: "auto"
        });
    };
    FileService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FileService_Factory() { return new FileService(i0.ɵɵinject(i1.ApiService)); }, token: FileService, providedIn: "root" });
    return FileService;
}());
export { FileService };
